import { LicenseInfo } from "@mui/x-license-pro";

export function initMuiXLicense() {
  const key = process.env.REACT_APP_MUIX_LICENSE_KEY
  if (key) LicenseInfo.setLicenseKey(key);
}